import React from 'react'
import { useNavigate } from 'react-router-dom'

import Header from '@pages/companies/header'
import ArrowBack from '@components/arrowBack'
import Title from '@components/text/title'
import SelectLoan from './selectLoan'

import {
  Container, TitleContainer
} from './styles'

const LoansDetail = () => {
  const navigate = useNavigate()
  return (
    <Container>
      <Header />
      <TitleContainer>
        <ArrowBack onClick={() => { navigate(-1) }} />
        <Title>Empréstimo de Equipamentos</Title>
      </TitleContainer>
      <SelectLoan />
    </Container>
  )
}

LoansDetail.propTypes = {
}

export default LoansDetail
